import AdminUsersBlock from "../../components/personal/AdminSettingsPage/AdminUsers/AdminUsersBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const AdminUsers = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Пользователи"}>
            <AdminUsersBlock/>
        </TypicalPageStructure>
        </>
    )
}
export default AdminUsers;